
import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { TransitRulingPlanet } from './TransitRulingPlanet';
import { BirthTimeRulingPlanet } from '../KPPage/BirthTimeRulingPlanet';
import { BirthTimeRulingPeriod } from '../KPPage/BirthTimeRulingPeriod';
import { CurrentRulingPeriod } from '../KPPage/CurrentRulingPeriod';

export function RulingPlanetTab ({menuArray,userData,clientData}) {
  return(
    <Collapse in={menuArray[0]} className="m-0 p-0 ">
      <Row id="rulingPlanetTab" className="m-0 p-0">
        <Col xs={12} lg={6} className="m-0 p-2 pt-0">
          <BirthTimeRulingPlanet clientData={clientData}/>
          <BirthTimeRulingPeriod userData={userData} clientData={clientData}/>
        </Col>
        <Col xs={12} lg={6} className="m-0 p-2 pt-0">
          <TransitRulingPlanet clientData={clientData}/>
          <CurrentRulingPeriod clientData={clientData}/>
        </Col>
      </Row>
    </Collapse>
    );
}